import { Col, DatePicker, Form, InputNumber, Row } from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import React from "react";
import CTConfigurationService from "../../Services/CTConfigurationService";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddRnDRates = ({ id, record, onDismiss, isViewOnly = false }: any) => {
  const [form] = useForm();
  const { openNotification } = React.useContext(adminContext);

  React.useEffect(() => {
    if (id !== undefined && id !== null && id !== "") {
      form.setFieldsValue({
        startDate: record?.startDate ? dayjs(record?.startDate) : undefined,
        minAmount: record?.minAmount,
        minRate: record?.minRate,
        smeRate: record?.smeRate,
        smeVaccRate: record?.smeVaccRate,
        taxRate: record?.taxRate,
        lcsRate: record?.lcsRate,
        lcsVaccRate: record?.lcsVaccRate,
        lTaxRate: record?.lTaxRate,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <SAModal
      width={680}
      open={true}
      footer={isViewOnly ? null : undefined}
      title={`${id ? 'Edit' : 'Add'} R&D rates`}
      okText={"Save"}
      cancelText={"Cancel"}
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        let Id = id === undefined || id === null ? "" : id;
        let values = undefined;
        values = await form.validateFields().then(() => {
          values = form.getFieldsValue();
          return form.getFieldsValue();
        }).catch((err) => { });

        if (values !== undefined) {
          let res = await CTConfigurationService.addRnDRateItem(values, Id);
          if (res.status) {
            onDismiss(true);
          } else {
            openNotification(res.message);
          }
        } else {
          openNotification("error", "Fill Mandatory Fields");
        }
      }}
    >
      <Form form={form} disabled={isViewOnly} requiredMark={true}>
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Mandatory field",
                },
              ]}
              label="Start date"
              name="startDate"
            >
              <DatePicker
                placeholder="Start date"
                format='DD/MM/YYYY'
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Minimum amount"
              name="minAmount"
            >
              <InputNumber
                controls={false}
                placeholder="Minimum amount"
                prefix="£"
                onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Minimum rate"
              name="minRate"
            >
              <InputNumber
                controls={false}
                placeholder="Minimum rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="SME RnD relief rate"
              name="smeRate"
            >
              <InputNumber
                controls={false}
                placeholder="SME RnD relief rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="SME vacc RnD relief rate"
              name="smeVaccRate"
            >
              <InputNumber
                controls={false}
                placeholder="SME vacc RnD relief rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="SME tax rate"
              name="taxRate"
            >
              <InputNumber
                controls={false}
                placeholder="SME tax rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="LCS RnD relief rate"
              name="lcsRate"
            >
              <InputNumber
                controls={false}
                placeholder="LCS RnD relief rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="LCS vacc RnD relief rate"
              name="lcsVaccRate"
            >
              <InputNumber
                controls={false}
                placeholder="LCS vacc RnD relief rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="LCS tax rate"
              name="lTaxRate"
            >
              <InputNumber
                controls={false}
                placeholder="LCS tax rate"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 26 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SAModal>
  );
};

export default AddRnDRates;
